import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { DEFAULT_USER, IS_DEMO } from 'config.js';
import { messages } from 'lang/messages/messages';
import { actions } from 'react-table';

const initialState = {
    editorArticle: {},
    editornotification: {},
    editorsendmail: {},
    revForm: {},
    editorAssignedReviewerlist: {},
    submitDecision: {},
    acceptDeline: {},

};

const EditorArticleSlice = createSlice({
    name: 'editorarticle',
    initialState,
    reducers: {
        setToast(state, action) {
            state.editornotification = action.payload
        },
        setEditorArticle(state, action) {
            state.editorArticle = action.payload
        },
        setEditorSendMail(state, action) {
            state.editorsendmail = action.payload
        },
        setRevForm(state, action) {
            state.revForm = action.payload
        },
        setEditorAssignedReviewerList(state, action) {
            state.editorAssignedReviewerlist = action.payload
        },
        setSubmitDecision(state, action) {
            state.submitDecision = action.payload
        },
        setAcceptDecline(state, action) {
            state.acceptDeline = action.payload
        }
    },
});
export const EditorArticleListApi = (tokendata, page, limit, search,journal_id) => async (dispatch) => {
    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/ats/editor/articleManuscrptList?page=${page}&limit=${limit}&search=${search}&type=&journal_uuid=${journal_id}`,
        {
            headers: {
                "authorization": ` Bearer ${tokendata}`
            }
        }
    )
        .then((res) => {
            console.log(res, "jfdd")
            dispatch(setEditorArticle(res?.data))
        })
        .catch((err) => {
            console.log(err?.response, "errerrr");

        })
}

export const EditorSendEmailApi = (payload, tokendata) => async (dispatch) => {
    const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/ats/author/sendEmailToEditorOffice`, payload,
        {
            headers: {
                "Authorization": ` Bearer ${tokendata}`
            }
        }
    )
        .then((res) => {
            console.log(res, "jhri")
            dispatch(setEditorSendMail(res?.data))
            dispatch(setToast({
                status: true, message: res?.data?.message
            }))
        })
        .catch((err) => {
            console.log(err?.response)
            dispatch(setToast({
                status: false, message: err?.response?.data?.message
            }))
        })
}


export const EditoruploadFilesApi = (tokendata, uuid, payload) => async (dispatch) => {

    const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/ats/manuscriptupdate/attachMoreFiles/${uuid}`, payload,
        {
            headers: {
                "Authorization": `Bearer ${tokendata}`,
            },
        }
    ).then((res) => {
        console.log(res, "fsdfffdfvfbg")

        dispatch(
            setToast({
                status: true,
                message: res?.data?.message,
            }))


    })
        .catch((err) => {
            console.log(err?.response, "wddssgfbhj");
            dispatch(
                setToast({
                    status: false,
                    message: err?.response?.data?.message,
                })
            )
        })

}

export const EditorArticleAcceptDeclineApi = (tokendata, payload) => async (dispatch) => {

    const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/ats/editor/agree/decline`, payload,
        {
            headers: {
                "Authorization": `Bearer ${tokendata}`,
            },
        }
    ).then((res) => {
        console.log(res, "fsdfffdfvfbg")

        dispatch(
            setToast({
                status: true,
                message: res?.data?.message,
            }))


    })
        .catch((err) => {
            console.log(err?.response, "wddssgfbhj");
            dispatch(
                setToast({
                    status: false,
                    message: err?.response?.data?.message,
                })
            )
        })

}

export const RevFormApi = (tokendata, page, limit, search, uuid) => async (dispatch) => {
    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/ats/editor/reviewerFormsubmitList?page=${page}&limit=${limit}&search=${search}&manuscript_uuid=${uuid}`,
        {
            headers: {
                "Authorization": `Bearer ${tokendata}`,
            },
        }
    )
        .then((res) => {
            console.log(res, "njd939dj");
            dispatch(setRevForm(res?.data?.data))
        })
        .catch((err) => {
            console.log(err?.response, "jdfss");
        })
}
export const EditorAssignedReviewersListApi = (tokendata, uuid) => async (dispatch) => {

    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/ats/submitmanuscript/assignReviewerList/${uuid}`,
        {
            headers: {
                "authorization": ` Bearer ${tokendata}`
            }
        }
    )
        .then((res) => {
            console.log(res, "fsdfff")
            dispatch(setEditorAssignedReviewerList(res?.data?.data))
            // dispatch(setToast({
            //     status: true, message: res?.data?.message
            // }))


        })
        .catch((err) => {
            console.log(err?.response, "wddss");
            // dispatch(setToast({
            //     status: false, message: err?.response?.data?.message
            // }))

        })

}

export const SubmitDecisionApi = (tokendata, payload, uuid) => async (dispatch) => {

    const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/ats/manuscript/editorsubmitDecision/${uuid}`, payload,
        {
            headers: {
                "authorization": ` Bearer ${tokendata}`
            }
        }
    )
        .then((res) => {
            console.log(res, "fres")
            dispatch(setSubmitDecision(res?.data))
            dispatch(setToast({
                status: true, message: res?.data?.message
            }))
        })
        .catch((err) => {
            console.log(err?.response)
            dispatch(setToast({
                status: false, message: err?.response?.data?.message
            }))
        })



}









export const { setToast, setEditorArticle, setEditorSendMail, setRevForm, setAcceptDecline, setEditorAssignedReviewerList, setSubmitDecision } = EditorArticleSlice.actions;
const EditorArticleReducer = EditorArticleSlice.reducer;

export default EditorArticleReducer;
